<template>
  <svg viewBox="0 0 64 64">
    <svg>
      <svg id="technisch">
        <path
          d="M18.1,33.5l4.7,4.5L22,38.7l-4.7-4.5L18.1,33.5z M13.5,33.6c-2.1,0-3.9-1.6-3.9-3.7v0l2.8,2.7l3.8-3.6
                        l-2.9-2.7c0,0,0.1,0,0.1,0c2.1,0,3.9,1.6,3.9,3.7C17.4,32,15.7,33.6,13.5,33.6 M25.5,38L19,31.8c0.2-0.6,0.4-1.2,0.4-1.8
                        c0-3-2.6-5.5-5.8-5.5c-0.8,0-1.6,0.2-2.4,0.5l-1.3,0.6l3.7,3.5l-1,1l-3.7-3.5l-0.6,1.2c-0.3,0.7-0.5,1.5-0.5,2.2
                        c0,3,2.6,5.5,5.8,5.5c0.7,0,1.3-0.1,1.9-0.3l6.5,6.2L25.5,38z"
        />
        <path
          d="M52.6,49.9c0.2,0.7,0.4,1.5,0.4,2.3c0,0.8-0.1,1.6-0.4,2.4l-0.3,1l1.8,1l-0.8,1.3l-1.8-1l-0.7,0.7
                        c-1.2,1.2-2.7,2-4.3,2.3l-1.1,0.2v1.9h-1.6v-1.9l-1-0.2c-1.6-0.4-3.1-1.2-4.2-2.4l-0.7-0.8l-1.8,1l-0.8-1.3l1.8-1l-0.3-1
                        c-0.2-0.7-0.4-1.5-0.4-2.3c0-0.8,0.1-1.6,0.4-2.4l0.3-1l-1.7-1l0.8-1.3l1.8,1l0.7-0.7c1.2-1.2,2.7-2,4.3-2.3l1.1-0.2v-1.9h1.6v1.9
                        l1,0.2c1.6,0.4,3.1,1.2,4.3,2.4l0.7,0.8l1.8-1l0.8,1.3l-1.8,1L52.6,49.9z M54.9,52.2c0-0.8-0.1-1.6-0.3-2.4l2.1-1.2L54,44.2
                        l-2.1,1.1c-1.3-1.2-2.8-2.1-4.5-2.5v-2.3H42v2.3c-1.7,0.4-3.3,1.3-4.6,2.5L35.3,44l-2.7,4.4l2.1,1.1c-0.2,0.8-0.4,1.7-0.4,2.6
                        c0,0.8,0.1,1.6,0.3,2.4l-2.1,1.2l2.7,4.4l2.1-1.1c1.3,1.2,2.8,2.1,4.5,2.5v2.3h5.4v-2.3c1.7-0.4,3.3-1.3,4.6-2.5l2.1,1.2l2.7-4.4
                        l-2.1-1.1C54.8,53.9,54.9,53.1,54.9,52.2"
        />
        <path
          d="M44.6,56.5c-2.5,0-4.5-1.9-4.5-4.3s2-4.3,4.5-4.3c2.5,0,4.5,1.9,4.5,4.3S47.1,56.5,44.6,56.5 M44.6,46.1
                        c-3.5,0-6.4,2.7-6.4,6.1s2.9,6.1,6.4,6.1c3.5,0,6.4-2.7,6.4-6.1S48.1,46.1,44.6,46.1"
        />
        <path
          d="M19.2,12.6c0.1-0.4,0.2-0.6,0.2-0.6l1.3-0.4c1-0.3,1.2-1.3,1.3-2c0-0.1,0-0.2,0.1-0.3
                        c1.5-5.8,6.9-7.9,11.4-7.5C36.3,2,39.2,3.5,40.8,6c-1.3-1-2.9-1.6-4.6-1.8c-3.9-0.4-8.8,1.4-10.1,6.5l1.7,0.4c1-4.1,5-5.6,8.1-5.2
                        c2.6,0.3,5.7,2,5.7,5.8l1.1,0l0,1.6h-1.2l-22.4,0C19.2,13.2,19.2,12.9,19.2,12.6 M31.7,23.4c-4.5,0-8.2-3.5-8.2-7.8
                        c0-0.2,0.1-0.5,0.1-0.7l16.3,0c0,0.2,0.1,0.5,0.1,0.7C39.9,19.9,36.2,23.4,31.7,23.4 M19.1,14.9h2.3h0.2c0,0.2-0.1,0.4-0.1,0.7
                        c0,5.4,4.6,9.7,10.2,9.7c5.6,0,10.2-4.4,10.2-9.7c0-0.2,0-0.5-0.1-0.7h0.6h0.7c0.8,0,1.4-0.6,1.4-1.3l0-2.2c0-0.5-0.2-0.9-0.7-1.1
                        C43.6,4,38.6,0.6,33.7,0.1C28.5-0.5,22.1,2,20.4,8.8c0,0.1-0.1,0.3-0.1,0.4c0,0.2-0.1,0.7-0.1,0.7l-1.3,0.4c-1.2,0.4-1.6,2-1.4,3
                        C17.7,14.6,18.5,14.9,19.1,14.9"
        />
        <path
          d="M20.3,41l-2-1.9c0,0.2-0.1,0.3-0.1,0.5v10.1H29c0.2-0.7,0.4-1.3,0.7-1.9h-9.4V41z"
        />
        <path
          d="M43.2,39h2c-0.4-6.8-6.2-12.2-13.5-12.2c-4.4,0-8.3,2-10.8,5.1l1.4,1.4c2.1-2.8,5.5-4.6,9.3-4.6
                        C37.9,28.7,42.8,33.3,43.2,39"
        />
      </svg>
    </svg>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconTechnisch extends Vue {}
</script>
